import React from 'react';
import PropTypes from 'prop-types';
import styles from '../Footer.module.scss';

const Resources = ({ isClient, omitHeading = false }) => {
  return (
    <ul className={styles.linkList}>
      {!omitHeading && (
        <li>
          <a href="/hire-a-freelancer/programming">Resources</a>
        </li>
      )}
      {!isClient && (
        <li>
          <a href="/freelancers">For freelancers</a>
        </li>
      )}
      <li>
        <a href="https://help.twine.net/">Help &amp; FAQs</a>
      </li>
      <li>
        <a href="/enterprise">For business &amp; enterprise</a>
      </li>
      <li>
        <a href="/ai">For AI and data scientists</a>
      </li>
      <li>
        <a href="/freelance/one-page-website">One-page website</a>
      </li>
      <li>
        <a href="/toolkits/freelancer">Freelancer toolkit</a>
      </li>
      <li>
        <a href="/toolkits/startup">Startup toolkit</a>
      </li>
      <li>
        <a href="/blog/">News and blog</a>
      </li>
    </ul>
  );
};

Resources.propTypes = {
  isClient: PropTypes.bool,
  omitHeading: PropTypes.bool,
};

export default Resources;
